<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <loading-provider :loading="loading">
      <ik-data-table
        :filter="{dataTerminalId: dataTerminalId}"
        :icon="'mdi-calendar-clock'"
        :model="model"
        :use-default-action="false"
        entity-name="cloudOrder"
      >
        <template
          #item.checkDetail="{item}"
        >
          <v-btn
            :height="!$vuetify.breakpoint.lgAndUp ? '40px' : ''"
            :icon="!$vuetify.breakpoint.lgAndUp"
            :style="!$vuetify.breakpoint.lgAndUp ? 'border-radius: 12px; background: #f57c00;' : ''"
            :width="!$vuetify.breakpoint.lgAndUp ? '40px' : ''"
            color="amber lighten-4 black--text"
            elevation="0"
            small
            @click.stop="goto(item)"
          >
            <template v-if="!$vuetify.breakpoint.lgAndUp">
              <v-icon color="white">
                mdi-cog
              </v-icon>
            </template>
            <template v-if="$vuetify.breakpoint.lgAndUp">
              <div
                :class="!$vuetify.breakpoint.lgAndUp ? 'text-truncate' : ''"
                :style="!$vuetify.breakpoint.lgAndUp ? 'max-width: 100px;' : ''"
              >
                {{ $t('ProductDetails') }}
              </div>
            </template>
          </v-btn>
        </template>
      </ik-data-table>
    </loading-provider>
    <v-dialog
      v-model="showDetailInfoDialog"
      max-width="800px"
    >
      <v-card
        color="#f6f6f6"
        tile
      >
        <takeaway-order-detail-info
          :info="detailInfo"
          @close-dialog="closeDialog"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import { getDataterminalByDeviceId } from '@/model/dataLayer/api/takeaway/TakeawayManager'
import { getCurrentDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'
import LoadingProvider from '@/views/widget/LoadingProvider'
import CloudList from '@/model/dataLayer/api/takeaway/CloudList'
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable'
import TakeawayOrderDetailInfo from '@/views/AadenPages/extraModules/takeaway/TakeawaySetting/TakeawayOrderDetailInfo'

export default {
  components: {
    TakeawayOrderDetailInfo,
    IkDataTable,
    LoadingProvider
  },
  data: function () {
    return ({
      showDetailInfoDialog: false,
      model: CloudList,
      detailInfo: null,
      loading: false,
      dataTerminalId: -1
    })
  },
  async mounted () {
    await this.reload()
  },
  methods: {
    async reload () {
      this.loading = true
      const storeId = await getCurrentDeviceId()
      this.dataTerminalId = (await getDataterminalByDeviceId(storeId))?.id
      this.loading = false
    },
    goto (item) {
      this.detailInfo = item
      this.showDetailInfoDialog = true
    },
    closeDialog () {
      this.reload()
      this.showDetailInfoDialog = false
    }
  }
}
</script>
